'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _get3 = require('lodash/get');

var _get4 = _interopRequireDefault(_get3);

var _isEmpty3 = require('lodash/isEmpty');

var _isEmpty4 = _interopRequireDefault(_isEmpty3);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _cloud = require('redux/modules/cloud');

var cloudActions = _interopRequireWildcard(_cloud);

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _index = require('components/index');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var CloudUploader = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    submittedCloudFiles: state.project.submittedCloudFiles
  };
}, (0, _extends3.default)({}, cloudActions, projectActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(CloudUploader, _Component);

  function CloudUploader() {
    (0, _classCallCheck3.default)(this, CloudUploader);
    return (0, _possibleConstructorReturn3.default)(this, (CloudUploader.__proto__ || (0, _getPrototypeOf2.default)(CloudUploader)).apply(this, arguments));
  }

  (0, _createClass3.default)(CloudUploader, [{
    key: 'onAddFromCloud',
    value: function onAddFromCloud(files) {
      var _props = this.props,
          uploadFromCloud = _props.uploadFromCloud,
          submitCloudFile = _props.submitCloudFile,
          projectId = _props.projectId,
          setCloudFileSuccessStatus = _props.setCloudFileSuccessStatus,
          setCloudFileFailedStatus = _props.setCloudFileFailedStatus,
          addFailedMedia = _props.addFailedMedia,
          onCloudUpload = _props.onCloudUpload,
          setCloudFileMetadata = _props.setCloudFileMetadata,
          part = _props.part;

      if ((0, _isEmpty4.default)(files)) {
        return false;
      }

      files.map(function (file) {
        submitCloudFile((0, _extends3.default)({}, file));
        uploadFromCloud((0, _extends3.default)({ projectId: projectId, part: part }, file)).promise.then(function (resp) {
          var cloudFile = (0, _get4.default)(resp.data, [0]);
          setCloudFileMetadata({ uniqId: file.uniqId, metadata: cloudFile });
          onCloudUpload(cloudFile);
          return setCloudFileSuccessStatus(file.uniqId);
        }).catch(function () {
          addFailedMedia((0, _extends3.default)({}, file), projectId);
          return setCloudFileFailedStatus(file.uniqId);
        });
      });
    }
  }, {
    key: 'onUploadFromCloud',
    value: function onUploadFromCloud(file) {
      var onCloudUpload = this.props.onCloudUpload;

      onCloudUpload(file);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          projectId = _props2.projectId,
          fileTypes = _props2.fileTypes,
          disabled = _props2.disabled;


      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_index.DropboxPopup, { onAdd: this.onAddFromCloud, fileTypes: fileTypes, disabled: disabled }),
        _react2.default.createElement(_index.BoxcomPopup, { projectId: projectId, onUpload: this.onUploadFromCloud, fileTypes: fileTypes, disabled: disabled })
      );
    }
  }]);
  return CloudUploader;
}(_react.Component), _class3.propTypes = {
  addFailedMedia: _propTypes2.default.func,
  disabled: _propTypes2.default.bool,
  fileTypes: _propTypes2.default.array,
  onCloudUpload: _propTypes2.default.func,
  part: _propTypes2.default.number,
  projectId: _propTypes2.default.number,
  setCloudFileFailedStatus: _propTypes2.default.func,
  setCloudFileMetadata: _propTypes2.default.func,
  setCloudFileSuccessStatus: _propTypes2.default.func,
  submitCloudFile: _propTypes2.default.func,
  uploadFromCloud: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onAddFromCloud', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onAddFromCloud'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onUploadFromCloud', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onUploadFromCloud'), _class2.prototype)), _class2)) || _class);
exports.default = CloudUploader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Cloud/CloudUploader/CloudUploader.js
// module id = 1971
// module chunks = 1